export default "https://cdn.questicon.mathletics.com/assets/audio/correct2Star-db19ce5a2c80681812676df89df72a7d.mp3";